import React, { useEffect, useState } from "react";
import { useForm, Controller, reset } from "react-hook-form";
import "../adminProfile/adminProfile.css";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Typography,
} from "@mui/material";
import { useAuth } from "../../context/API_Client";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import PhoneInput from "react-phone-number-input";

import ChangePassword from "./changePassword";
import CustomButton from "../../reusableComponents/CustomButton";
import phonevalidator from "../utils/phoneValidation";
import "../analytics/analytics.css";
import { useEditButtonContext } from "./EditButtonContext";
import { customToast } from "../../reusableComponents/customToaster/customToast";

function PersonalInfo() {
  const { updateMerchantProfiles, merchantProfiles } = useAuth();
  const { isEditing, activeEditingPage, startEditing, stopEditing } =
    useEditButtonContext();

  const [getMerchantProfiles, setMerchantProfiles] = useState([]);
  const [password, setPassword] = useState("12345678");
  const [open, setOpen] = useState(false);
  const [openCP, setOpenCP] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [myRole, setMyRole] = useState("");
  const [editChange, setEditChange] = useState(false);
  const [disabledFullName, setDisabledFullname] = useState(true);
  const [disabledMobileNumber, setDisabledMobileNumber] = useState(true);

  const schema = yup.object({
    fullName: yup
      .string()
      .required("Please enter full name")
      .matches(/^[a-zA-Z\s.',]*$/, "Special characters not allowed"),
    mobileNumber: yup
      .string()
      .required("Mobile number is required")
      .test({
        name: "phone-validation",
        message: (value) => phonevalidator(value, countryLetter),
        test: (value) => !phonevalidator(value, countryLetter),
      }),
  });

  const { handleSubmit, control, formState, setValue, trigger } = useForm({
    resolver: yupResolver(schema),
  });

  const handleOpenCP = () => {
    setOpenCP(true);
  };

  const handleCloseCP = (event) => {
    setOpenCP(false);
  };

  const handleEdit = () => {
    setEditChange(!editChange);
    startEditing("personalInfo");
    setValue("fullName", getMerchantProfiles?.name);
    setValue("mobileNumber", getMerchantProfiles?.phoneNumber);
    setversionPI(getMerchantProfiles?.version);

    setDisabledFullname(!disabledFullName);
    setDisabledMobileNumber(!disabledMobileNumber);

    formState.errors.fullName = false;
    formState.errors.mobileNumber = false;
  };

  const handleSavedChanges = () => {
    setEditChange(!editChange);
    stopEditing();
    setDisabledFullname(!disabledFullName);
    setDisabledMobileNumber(!disabledMobileNumber);
    customToast("success", "high", "Changes Saved");
  };

  const handleCancel = () => {
    setEditChange(!editChange);
    stopEditing();
    setValue("fullName", getMerchantProfiles?.name);
    setValue("mobileNumber", getMerchantProfiles?.phoneNumber);
    setversionPI(getMerchantProfiles?.version);

    setDisabledFullname(!disabledFullName);
    setDisabledMobileNumber(!disabledMobileNumber);

    formState.errors.fullName = false;
    formState.errors.mobileNumber = false;
  };

  const [emailaddress, setEmailAddress] = useState("");
  const [versionPI, setversionPI] = useState();

  useEffect(() => {
    merchantProfiles(
      function (data) {
        setMerchantProfiles(data);
        setValue("fullName", data?.name);
        setMyRole(data?.roles);
        setEmailAddress(data?.email);
        setValue("mobileNumber", data?.phoneNumber);
        setversionPI(data?.version);
      },
      function (errorMsg) { }
    );
  }, []);

  const [countryLetter, setCountryLetter] = useState("IN");
  const [errorMsg, setErrorMsg] = useState("");
  const handleCountryChange = (country) => {
    setCountryLetter(country);
  };

  const onSubmit = (formData, event) => {
    var version = versionPI;
    updateMerchantProfiles(
      {
        name: formData.fullName,
        phoneNumber: formData.mobileNumber,
        roles: myRole,
        version,
      },
      function (data) {
        getMerchantProfiles.name = formData.fullName;
        getMerchantProfiles.phoneNumber = formData.mobileNumber;
        getMerchantProfiles.version = data.version;

        setValue("fullName", getMerchantProfiles?.name);
        setEmailAddress(getMerchantProfiles?.email);
        setValue("mobileNumber", getMerchantProfiles?.phoneNumber);
        setversionPI(getMerchantProfiles?.version);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
    handleSavedChanges();
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} style={{ width: "100%" }}>
        <div className="mainDivCreateform2">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography className="subHeaderMedium font-black-highest">
              Personal Information
            </Typography>
            <div>
              {editChange ? (
                <div style={{ display: "flex" }}>
                  <div style={{ paddingRight: "20px" }}>
                    <CustomButton
                      text={"Cancel"}
                      type={"primary"}
                      size={"sm"}
                      onClick={handleCancel}
                    />
                  </div>
                  <CustomButton
                    text={formState.isSubmitting ? "Saving..." : "Save Changes"}
                    type={"primary"}
                    size={"sm"}
                    variant={"contained"}
                    onClick={handleSubmit(onSubmit)}
                    disabled={formState.isSubmitting || errorMsg.length != 0}
                  />
                </div>
              ) : (
                <CustomButton
                  text={"Edit Info"}
                  type={"primary"}
                  variant={"contained"}
                  size={"sm"}
                  onClick={handleEdit}
                  disabled={isEditing && activeEditingPage === "businessInfo"}
                />
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              marginTop: "28px",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "45%" }}>
              <InputLabel
                htmlFor="fullName"
                className="fontCreate"
                required={true}
                style={{ color: "#547187" }}
              >
                Full Name
              </InputLabel>
              <Controller
                name="fullName"
                control={control}
                render={({ field }) => (
                  <OutlinedInput
                    {...field}
                    className="textFieldCreate"
                    id="fullName"
                    size="small"
                    name="fullName"
                    style={{
                      color: disabledFullName ? "gray" : "black",
                      width: "100%",
                    }}
                    disabled={disabledFullName}
                    inputProps={{ maxLength: 25 }}
                    aria-describedby="outlined-name-helper-text"
                  />
                )}
              />
              {formState.errors.fullName && (
                <div
                  className="error"
                  style={{
                    color: "#B9232F",
                    fontSize: "10px",
                    marginTop: "2px",
                  }}
                >
                  <img
                    src="/assets/errorOutline.svg"
                    style={{ height: "12px", width: "12px" }}
                  />{" "}
                  {formState.errors.fullName.message}
                </div>
              )}
            </div>
            <div style={{ width: "45%" }}>
              <InputLabel className="fontCreate" style={{ color: "#547187" }}>
                My Role
              </InputLabel>

              <Controller
                name="myRole"
                control={control}
                render={({ field }) => (
                  <OutlinedInput
                    {...field}
                    className="textFieldCreate"
                    size="small"
                    value={myRole ? myRole : "Admin"}
                    style={{ color: "gray", width: "100%" }}
                    disabled={true}
                    aria-describedby="outlined-name-helper-text"
                  />
                )}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              marginTop: "28px",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "45%" }}>
              <InputLabel className="fontCreate" style={{ color: "#547187" }}>
                Primary Email Address
              </InputLabel>
              <Controller
                name="emailAddress"
                control={control}
                render={({ field }) => (
                  <OutlinedInput
                    {...field}
                    className="textFieldCreate"
                    size="small"
                    name="emailAddress"
                    style={{ color: "gray", width: "100%" }}
                    value={emailaddress}
                    disabled={true}
                    aria-describedby="outlined-title-helper-text"
                  />
                )}
              />
            </div>
            <div style={{ width: "45%" }}>
              <InputLabel
                htmlFor="mobileNumber"
                className="fontCreate"
                style={{
                  color: disabledMobileNumber ? "gray" : "black",
                  width: "100%",
                }}
                required={true}
              >
                Primary Mobile Number
              </InputLabel>

              <Controller
                name="mobileNumber"
                control={control}
                render={({ field }) => (
                  <div
                    style={{
                      paddingTop: "-80px",
                      color: "white",
                      width: "100%",
                    }}
                  >
                    <PhoneInput
                      disabled={disabledMobileNumber}
                      className={
                        disabledMobileNumber ? "disabledPhoneNumber" : ""
                      }
                      style={{
                        color: disabledMobileNumber ? "gray" : "black",
                        paddingTop: "-40px",
                        paddingLeft: "9px",
                        width: "100%",
                        height: "42px",
                        borderRadius: "4px",
                        border: "1.4px solid var(--neutral-5, #CBCACA)",
                      }}
                      {...field}
                      international
                      onCountryChange={(country) => {
                        handleCountryChange(country);
                      }}
                      onChange={(value) => {
                        setValue("mobileNumber", value);
                        trigger("mobileNumber");
                      }}
                      countryCallingCodeEditable={false}
                      defaultCountry="IN"
                    />
                  </div>
                )}
              />
              {formState?.errors?.mobileNumber && (
                <div
                  className="error"
                  style={{
                    color: "#B9232F",
                    fontSize: "10px",
                    marginTop: "2px",
                  }}
                >
                  <img
                    src="/assets/errorOutline.svg"
                    style={{ height: "12px", width: "12px" }}
                  />{" "}
                  {formState.errors.mobileNumber.message}
                </div>
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              marginTop: "28px",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "45%" }}>
              <InputLabel className="fontCreate" style={{ color: "#547187" }}>
                Password
              </InputLabel>

              <Controller
                name="password"
                control={control}
                render={({ field }) => (
                  <OutlinedInput
                    {...field}
                    className="textFieldCreate"
                    name="password"
                    aria-describedby="outlined-title-helper-text"
                    style={{ color: "gray", width: "100%" }}
                    disabled={true}
                    type={showPassword ? "" : "password"}
                    value={password}
                    endAdornment={
                      <InputAdornment position="end">
                        {editChange ? (
                          <Button
                            style={{
                              color: "#403E9F",
                              fontWeight: 600,
                              width: "136px",
                              textTransform: "none",
                              fontFamily: "poppins",
                            }}
                            onClick={handleOpenCP}
                          >
                            Change Password
                          </Button>
                        ) : null}
                      </InputAdornment>
                    }
                  />
                )}
              />
            </div>
          </div>
        </div>
      </form>
      <ChangePassword openCP={openCP} onCloseCP={handleCloseCP} />
    </>
  );
}

export default PersonalInfo;
